  import { useEffect, useState } from 'react'
  
  import countryEmergencyNumbers from '../assets/data/country-sos-data.json'
  
  export const useEmergencyPhoneNumber = () => {
    const [isLoading, setIsLoading] = useState(false)
    const [position, setPosition] = useState<GeolocationPosition>()
  
    const [sharedNumber, setSharedNumber] = useState('')
    const [ambulanceNumber, setAmbulanceNumber] = useState('')
    const [policeNumber, setPoliceNumber] = useState('')
    const [fireNumber, setFireNumber] = useState('')
    const [error, setError] = useState<Error | null>(null)
  
    useEffect(() => {
      getEmergencyNumbers()
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

  
    const getEmergencyNumbers = async () => {
      setIsLoading(true)
      setError(null)
      try {
        navigator.geolocation.getCurrentPosition((position) => {
            setPosition(position)
        }, (error) => {
            console.error(error)
            setError(new Error('No position found'))
        }, {
            enableHighAccuracy: false 
        })

        const res = await fetch(
          `https://nominatim.openstreetmap.org/reverse?format=jsonv2&lat=${position?.coords?.latitude}&lon=${position?.coords?.longitude}`
        )

        const resJson = await res.json()
        const countryISOCode = resJson.address.country_code.toUpperCase()

        if (countryISOCode) {
          const emergencyData = countryEmergencyNumbers.find(
            (emergencyData) =>
              emergencyData.Country.ISOCode === countryISOCode
          )
  
          const ambulanceNumber = emergencyData?.Ambulance?.All?.[0]
          const policeNumber = emergencyData?.Police?.All?.[0]
          const fireNumber = emergencyData?.Fire?.All?.[0]
  
          // Merge if all numbers are the same
          let sharedNumber = ''
          if (
            ambulanceNumber === policeNumber &&
            ambulanceNumber === fireNumber
          ) {
            sharedNumber = ambulanceNumber ?? ''
          }
  
          setSharedNumber(sharedNumber)
          setAmbulanceNumber(ambulanceNumber ?? '')
          setPoliceNumber(policeNumber ?? '')
          setFireNumber(fireNumber ?? '')
        }
      } catch (error) {
        setError(new Error('No emergency numbers found'))
      } finally {
        setIsLoading(false)
      }
    }
  
    return {
      isLoading,
      sharedNumber,
      ambulanceNumber,
      policeNumber,
      fireNumber,
      error,
    }
  }
  